import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

interface ByzGrdEditButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
}

const StyledButton = styled(Button)<{ disabled?: boolean }>(({ theme, disabled }) => ({ //IDOGAN;452471;05052025;DISABLED OZELLIGI EKLENDI ONA GORE RENK DEGISTIRMESI SAGLANDI
  width: "35px",
  height: "35px",
  borderRadius: "100px",
  padding: 0,
  minWidth: "unset",

  backgroundColor: disabled ? "#AEADA6" : "#2196F3",
  transition: "background-color 0.2s ease-in-out, opacity 0.2s ease-in-out",
  boxShadow: disabled
    ? "none"
    : "0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: disabled ? 0.6 : 1,
  "&:hover": {
    backgroundColor: disabled ? "#AEADA6" : "#2979C3",
  },
}));

const ByzGrdEditButton: React.FC<ByzGrdEditButtonProps> = ({ onClick, link, disabled }) => {
  const [hover, setHover] = useState(false);

  const buttonContent = (
    <img
      src="/assets/icons/edit-change/edit-change.svg"
      alt="Düzenle"
      style={{
        width: "16px",
        height: "16px",
        transition: "opacity 0.2s ease-in-out",
        opacity: hover ? 1 : 0.9,
      }}
    />
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none", pointerEvents: disabled ? "none" : undefined }}>
      <StyledButton
        disabled={disabled}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {buttonContent}
      </StyledButton>
    </Link>
  ) : (
    <StyledButton
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {buttonContent}
    </StyledButton>
  );
};

export default ByzGrdEditButton;
